module.exports = __webpack_public_path__ + "static/media/96gal03.4a644a58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/96gal/96gal03.jpg
// module id = 279
// module chunks = 0